import {
    useCallback,
} from 'react'

import SkyNetTable from 'app/shared-components/SkyNetTable'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import SkyNetDomain from 'app/shared-components/SkyNetDomain'

import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'

import quoteKamDashboardRequests from 'app/requests/Quote/KAMDashboard.requests'
import preBookingsRequests from 'app/requests/Prebooking.requests'

import useStyles from './KamDashboard.style'
import kamUpcomingConfig from './configs/kamUpcoming.config'
import kamToBeCompletedConfig from './configs/kamToBeCompleted.config'
import kamDashboardConfig from './configs/kamCompleted.config'
import preBookingsConfig from './configs/preBookings.config'
import ToBeAssignedLanes from './ToBeAssignedLanes'

const DOMAIN_NAME = 'KamDashboard'
const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const KamDashboard = () => {
    const {
        classes,
    } = useStyles()
    const {
        AQuotes: AQuotesRoutes,
    } = useAccountManagementRoutes()

    const {
        PreBookings: PreBookingsRoutes,
    } = useOrderManagementRoutes()

    const onRowClick = useCallback(({
        id,
    }: { id: number }) => {
        AQuotesRoutes.Overview.navigate({
            params: {
                key: id,
            },
        })
    }, [AQuotesRoutes.Overview])

    const onRowClickPreBookings = ({
        id,
    }: { id: number }): void => {
        PreBookingsRoutes.Overview.navigate({
            params: {
                key: id,
            },
        })
    }

    return (
        <SkyNetDomain
            name={DOMAIN_NAME}
            editable={false}
            uniqField="quoteNumber"
        >
            <div className={classes.root}>
                <div className={classes.headerTitle}>
                    Dashboard
                    <div className={classes.actionWrapper} />
                </div>
                <div className={classes.tableWrapper}>
                    <SkyNetTable
                        onRowClick={onRowClick}
                        customUrl={quoteKamDashboardRequests.getUpcomingQuotes().url}
                        tableConfig={kamUpcomingConfig}
                        tableControls={tableControls}
                        isShowCounterTab
                        showSearch
                        paginationModeMatches
                    />
                </div>
                <div className={classes.tableWrapper}>
                    <SkyNetTable
                        onRowClick={onRowClick}
                        customUrl={quoteKamDashboardRequests.getToBeCompletedQuotes().url}
                        tableConfig={kamToBeCompletedConfig}
                        tableControls={tableControls}
                        isShowCounterTab
                        showSearch
                        paginationModeMatches
                    />
                </div>
                <div className={classes.tableWrapper}>
                    <SkyNetTable
                        onRowClick={onRowClick}
                        customUrl={quoteKamDashboardRequests.getCompletedQuotes().url}
                        tableConfig={kamDashboardConfig}
                        tableControls={tableControls}
                        isShowCounterTab
                        showSearch
                        paginationModeMatches
                    />
                </div>
                <div className={classes.headerTitle}>Unassigned Lanes</div>
                <div className={classes.tableWrapper}>
                    <ToBeAssignedLanes />
                </div>
                <div className={classes.headerTitle}>
                    Pre Bookings
                    <div className={classes.actionWrapper} />
                </div>
                <div className={classes.tableWrapper}>
                    <SkyNetTable
                        onRowClick={onRowClickPreBookings}
                        customUrl={preBookingsRequests.reviewWithCustomerNeeded().url}
                        tableConfig={preBookingsConfig}
                        tableControls={tableControls}
                        isShowCounterTab
                        showSearch
                        paginationModeMatches
                        data-testid="preBookingsTransports"
                    />
                </div>
            </div>
        </SkyNetDomain>
    )
}

export default KamDashboard
